import { render, staticRenderFns } from "./editask.vue?vue&type=template&id=655f1c2d&scoped=true&"
import script from "./editask.vue?vue&type=script&lang=js&"
export * from "./editask.vue?vue&type=script&lang=js&"
import style0 from "./editask.vue?vue&type=style&index=0&id=655f1c2d&lang=less&scoped=true&"
import style1 from "./editask.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f1c2d",
  null
  
)

export default component.exports